/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} Ateliere_Connect_Status_Caption_DetailsInputs */



/**
* | output |
* | --- |
* | "Getting details for caption file: {id}..." |
*
* @param {Ateliere_Connect_Status_Caption_DetailsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_caption_details = /** @type {((inputs: Ateliere_Connect_Status_Caption_DetailsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Caption_DetailsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Récupération des détails du fichier de sous-titres : ${i?.id}...`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Details zur Untertiteldatei werden abgerufen: ${i?.id}...`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Ottenimento dei dettagli per il file della didascalia: ${i?.id}...`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Получение информации о файле с подписями: ${i?.id}...`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Obteniendo detalles del archivo de subtítulos: ${i?.id}...`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`正在获取标题文件 ${i?.id} 的详细信息...`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`キャプション ファイルの詳細を取得しています: ${i?.id}...`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`कैप्शन फ़ाइल के लिए विवरण प्राप्त करना: ${i?.id}...`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Obtendo detalhes do arquivo de legenda: ${i?.id}...`)
	return /** @type {LocalizedString} */ (`Getting details for caption file: ${i?.id}...`)
});